import styled from 'styled-components'

export default styled.div`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;

  div {
    font-family: 'ABChanel PB Regular S', Arial, sans-serif;
    font-size: 10px;
    line-height: 1.2em;
    letter-spacing: -0.04em;
    padding-top: 0.4em;
    html[lang=tw] & {
      font-size: 12px;
    }
  }

  div:first-child {
    font-family: 'ABChanel PB Semibold L', Arial, sans-serif;
    font-size: 14px;
    line-height: 1.14em;
    letter-spacing: -0.02em;
    padding-top: 0.3em;
    font-weight: bold;
    html[lang=tw] & {
      font-size: 14px;
    }
  }
`



// WEBPACK FOOTER //
// ./src/styles/MultiLineTitle.js